package com.wintermar.inspection.core.ui.component.button.variant

import androidx.compose.runtime.Composable
import com.wintermar.inspection.core.ui.theme.LocalAppTheme

sealed class ButtonSizeVariant {
    @Composable
    abstract fun size(): ButtonSizeModel

    object Small : ButtonSizeVariant() {
        @Composable
        override fun size(): ButtonSizeModel {
            val dimension = LocalAppTheme.current.dimension
            return ButtonSizeModel(
                height = dimension.size.size7,
                verticalPadding = dimension.spacing.space0,
                horizontalPadding = dimension.spacing.space3
            )
        }
    }

    object Medium : ButtonSizeVariant() {
        @Composable
        override fun size(): ButtonSizeModel {
            val dimension = LocalAppTheme.current.dimension
            return ButtonSizeModel(
                height = dimension.size.size8,
                verticalPadding = dimension.spacing.space0,
                horizontalPadding = dimension.spacing.space3
            )
        }
    }

    object Large : ButtonSizeVariant() {
        @Composable
        override fun size(): ButtonSizeModel {
            val dimension = LocalAppTheme.current.dimension
            return ButtonSizeModel(
                height = dimension.size.size9,
                verticalPadding = dimension.spacing.space3,
                horizontalPadding = dimension.spacing.space3
            )
        }
    }

    object XLarge : ButtonSizeVariant() {
        @Composable
        override fun size(): ButtonSizeModel {
            val dimension = LocalAppTheme.current.dimension
            return ButtonSizeModel(
                height = dimension.size.size10,
                verticalPadding = dimension.spacing.space3,
                horizontalPadding = dimension.spacing.space4
            )
        }
    }

    object XXLarge : ButtonSizeVariant() {
        @Composable
        override fun size(): ButtonSizeModel {
            val dimension = LocalAppTheme.current.dimension
            return ButtonSizeModel(
                height = dimension.size.size11,
                verticalPadding = dimension.spacing.space0,
                horizontalPadding = dimension.spacing.space4
            )
        }
    }
}
